import { render, staticRenderFns } from "./time-reservation-success.vue?vue&type=template&id=a605ff90&scoped=true&lang=pug"
import script from "./time-reservation-success.vue?vue&type=script&lang=js"
export * from "./time-reservation-success.vue?vue&type=script&lang=js"
import style0 from "./time-reservation-success.vue?vue&type=style&index=0&id=a605ff90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a605ff90",
  null
  
)

export default component.exports